import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { LARGE_CARD_WIDTH, STANDARD_CARD_WIDTH } from "app/pages/sales-intelligence/pages/premium-features/configs";

export const StyledCardWrapper = styled(FlexColumn)<{ size?: "md" | "lg" }>`
    max-width: ${({ size }) => `${size === "lg" ? LARGE_CARD_WIDTH : STANDARD_CARD_WIDTH}px`};
    border-radius: 4px;
    background: ${colorsPalettes.carbon[0]};
    box-shadow: 0 3px 6px 0 rgba(14, 30, 62, 0.08);

    &:hover {
        box-shadow: rgba(14, 30, 62, 0.12) 0px 18px 34px;
    }
`;

export const StyledCardContainer = styled(FlexColumn)`
    padding: 32px;
`;

export const StyledCardHeader = styled(FlexRow)`
    gap: 4px;
    align-items: center;
    margin-bottom: 8px;
`;

export const StyledCardDescription = styled(Flex)`
    ${mixins.setFontVariant("body1", colorsPalettes.carbon[300])}
    margin-bottom: 12px;
    height: 61px;
`;

export const StyledIconWrapper = styled(Flex)`
    border-radius: 4px;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    background: #f2f6ff;
    margin-bottom: 16px;
`;

export const StyledCardTitle = styled(Flex)`
    ${mixins.setFontVariant("h5", colorsPalettes.carbon[400])}
    line-height: 27px;
`;

export const StyledCardTagsWrapper = styled(FlexRow)`
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 16px;
`;

export const StyledCardTag = styled(Flex)`
    border-radius: 35px;
    padding: 4px 8px;
    ${mixins.setFontVariant("subtitle2")}
    color:  rgba(42, 62, 82, 0.8);
    background: rgba(182, 190, 198, 0.2);
`;

export const StyledCardActionsWrapper = styled(FlexRow)`
    justify-content: space-between;
    align-items: flex-end;
`;
